export const FILE_TYPES = {
  PDF: "data:application/pdf;base64",
  TXT: "data:text/plain;charset=utf-8",
  STREAM: "data:application/octet-stream",
};

export const downloadFile = (
  file: string,
  name: string,
  type: string = FILE_TYPES.TXT
) => {
  const linkSource = `${type},${file}`;
  const downloadLink = document.createElement("a");
  const fileName = name;
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};
